import * as Utils from '../modules/utilities';

const accordion = () =>
{
    const accordionItems = document.querySelectorAll('[data-accordion]');
    const accordionContentPanes = document.querySelectorAll('[data-accordion-body]');

    accordionItems.forEach(function(item) {
        const accordionHeading = item.querySelector('[data-accordion-header]');
        accordionHeading.addEventListener('click', accordionControls);
    });

    function accordionControls(event)
    {
        const ID = event.target.getAttribute('aria-controls');
        const target = document.getElementById(ID);

        Utils.toggleElement(target);

    };

}

export { accordion }

